module.exports = "<div class=postcard-field> <h2 class=form-label> {{label}} </h2> <div class=video_embed-fluid> <iframe src={{videoUrl}} frameborder=0 allowfullscreen></iframe> </div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./app/main/posts/detail/post-video-value.html
// module id = 710
// module chunks = 0